import { ForsikringProducts } from '../comparison-table-config/product-config';

export const COMPACT_TABLE_PRODUCTS: ForsikringProducts[] = ['bil', 'bobil', 'bat', 'traktor'];
